import { Directive, Input } from "@angular/core";
import { Deck } from "@apiserver-rest/ponder-data-client-base";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { DeckBaseComponent } from "@ponder-features/user/decks/deck/deck-base.component";
import { ChartBaseComponent } from "@ponder-shared/charts/chart-base.component";

@Directive()
export abstract class MagicChartBaseComponent extends ChartBaseComponent {
    @Input({ required: true }) public deck!: Deck;
    @Input({ required: true }) public deckComponent!: DeckBaseComponent;

    constructor(events: EventBroker) {
        super(events);
    }
}